type NameInputProps = {
  onChange: (val: string) => void
  value: string
  disabled?: boolean
}

export const NameInput = ({ onChange, value, disabled }: NameInputProps) => {
  return (
    <div className="mb-6">
      <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
        Name*
      </label>
      <div className="mt-2">
        <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600 sm:max-w-md">
          <input
            type="text"
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            onChange={(e) => onChange(e.target.value)}
            placeholder="My destination"
            value={value}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
